export function TabindexDirective () {
    return {
        restrict: 'A',
        require: 'mdListItem',
        link: function ($scope, $el, $attrs, $ctrl) {
            $attrs.$observe('tabindex', function(newValue) {
                // apply non-zero tabindex to the focusable element
                // created by mdListItem, these 
                // are either a or button tags
                if (newValue === '-1') {
                    $el.find('a').attr('tabindex', newValue);
                    $el.find('button').attr('tabindex', newValue);
                } else {
                    $el.find('a').removeAttr('tabindex');
                    $el.find('button').removeAttr('tabindex');
                }
            });

        }
    };
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/tabindex/tabindex.ts